var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bg",
      style: _vm.customStyle,
      attrs: { id: _vm.previewMainDomId },
      on: { scroll: _vm.canvasScroll },
    },
    [
      _vm.canvasId === "canvas-main"
        ? _c("canvas-opt-bar", {
            ref: "canvas-opt-bar",
            attrs: { "canvas-style-data": _vm.canvasStyleData },
            on: { "link-export-pdf": _vm.downloadAsPDF },
          })
        : _vm._e(),
      _c(
        "div",
        {
          ref: _vm.previewRefId,
          style: _vm.canvasInfoMainStyle,
          attrs: { id: _vm.previewDomId },
        },
        [
          _vm.showUnpublishedArea
            ? _c("el-row", { staticClass: "custom-position" }, [
                _c(
                  "div",
                  { staticStyle: { "text-align": "center" } },
                  [
                    _c("svg-icon", {
                      staticStyle: { "font-size": "75px" },
                      attrs: { "icon-class": "unpublished" },
                    }),
                    _c("br"),
                    _c("span", [_vm._v(_vm._s(_vm.$t("panel.panel_off")))]),
                  ],
                  1
                ),
              ])
            : _vm.componentDataShow && _vm.componentDataShow.length === 0
            ? _c("el-row", { staticClass: "custom-position" }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isMainCanvas(),
                        expression: "isMainCanvas()",
                      },
                    ],
                  },
                  [_vm._v(_vm._s(_vm.$t("panel.panelNull")))]
                ),
              ])
            : _c(
                "div",
                {
                  ref: _vm.previewTempRefId,
                  staticClass: "main-class",
                  style: [_vm.canvasInfoTempStyle, _vm.screenShotStyle],
                  attrs: { id: _vm.previewTempDomId },
                  on: {
                    mouseup: _vm.deselectCurComponent,
                    mousedown: _vm.handleMouseDown,
                  },
                },
                _vm._l(_vm.componentDataInfo, function (item, index) {
                  return _c("ComponentWrapper", {
                    key: index,
                    ref: "viewWrapperChild",
                    refInFor: true,
                    attrs: {
                      config: item,
                      "canvas-id": _vm.canvasId,
                      "source-config": _vm.componentData[index],
                      "search-count": _vm.searchCount,
                      "in-screen": _vm.inScreen,
                      terminal: _vm.terminal,
                      "is-relation": _vm.relationFilterIds.includes(item.id),
                      filters:
                        _vm.filterMap[item.propValue && item.propValue.viewId],
                      "screen-shot": _vm.screenShot,
                      "canvas-style-data": _vm.canvasStyleData,
                      "show-position": _vm.showPosition,
                    },
                  })
                }),
                1
              ),
        ],
        1
      ),
      _vm.pdfExportShow
        ? _c(
            "el-dialog",
            {
              staticClass: "dialog-css2",
              attrs: {
                title:
                  "[" + _vm.panelInfo.name + "]" + _vm.$t("panel.pdf_export"),
                visible: _vm.pdfExportShow,
                width: "80%",
                top: "8vh",
                "destroy-on-close": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.pdfExportShow = $event
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    position: "absolute",
                    right: "70px",
                    top: "15px",
                  },
                },
                [
                  _c("svg-icon", {
                    staticClass: "ds-icon-pdf",
                    attrs: { "icon-class": "PDF" },
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("panel.switch_pdf_template"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.changePdfTemplate()
                        },
                      },
                      model: {
                        value: _vm.pdfTemplateSelectedIndex,
                        callback: function ($$v) {
                          _vm.pdfTemplateSelectedIndex = $$v
                        },
                        expression: "pdfTemplateSelectedIndex",
                      },
                    },
                    _vm._l(_vm.pdfTemplateAll, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: index },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c("PDFPreExport", {
                attrs: {
                  snapshot: _vm.snapshotInfo,
                  "panel-name": _vm.panelInfo.name,
                  "template-content": _vm.pdfTemplateContent,
                },
                on: { closePreExport: _vm.closePreExport },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-css",
          attrs: {
            visible: _vm.chartDetailsVisible,
            width: "80%",
            "destroy-on-close": true,
            "show-close": true,
            "append-to-body": false,
            top: "5vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.chartDetailsVisible = $event
            },
          },
        },
        [
          _vm.chartDetailsVisible
            ? _c(
                "span",
                {
                  staticStyle: {
                    position: "absolute",
                    right: "70px",
                    top: "15px",
                  },
                },
                [
                  _vm.showChartInfoType === "enlarge" &&
                  _vm.hasDataPermission("export", _vm.panelInfo.privileges) &&
                  _vm.showChartInfo &&
                  _vm.showChartInfo.type !== "symbol-map"
                    ? _c(
                        "el-button",
                        {
                          staticClass: "el-icon-picture-outline",
                          attrs: { size: "mini" },
                          on: { click: _vm.exportViewImg },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("chart.export_img")) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.showChartInfoType === "details" &&
                  _vm.hasDataPermission("export", _vm.panelInfo.privileges)
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "mini" },
                          on: { click: _vm.exportExcel },
                        },
                        [
                          _c("svg-icon", {
                            staticClass: "ds-icon-excel",
                            attrs: { "icon-class": "ds-excel" },
                          }),
                          _vm._v(
                            _vm._s(_vm.$t("chart.export")) + "Excel\n      "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.chartDetailsVisible
            ? _c("user-view-dialog", {
                ref: "userViewDialog-canvas-main",
                attrs: {
                  chart: _vm.showChartInfo,
                  "chart-table": _vm.showChartTableInfo,
                  "canvas-style-data": _vm.canvasStyleData,
                  "open-type": _vm.showChartInfoType,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }